import axios from 'axios';
import store from '@/store'
import Vue from 'vue';
import {getToken, getReshToken, setToken, setReshToken} from '@/utils/auth'
import {Message} from "element-ui";
//  让请求在浏览器中允许跨域携带cookie
axios.defaults.withCredentials = true;
// 使用自定义配置新建一个 axios 实例
const service = axios.create({
  // 表示跨域请求时是否需要使用凭证
  withCredentials: false, // default
  // 基础的请求地址
  baseURL: process.env.VUE_APP_API,
  // 设置超时时间 5s
  timeout: 50000000000000000,
});

// token 键定义
export const accessTokenKey = 'access-token'
export const refreshAccessTokenKey = `x-${accessTokenKey}`
// 清除 token
export const clearAccessTokens = () => {
  window.localStorage.removeItem(accessTokenKey)
  window.localStorage.removeItem(refreshAccessTokenKey)

  // 这里可以添加清除更多 Key =========================================
}

// 错误处理
export const throwError = (message) => {
  throw new Error(message)
}

// 请求拦截器，例如请求的时候在头部加上请求的token
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = 'Bearer ' + getToken()
    config.headers['X-Authorization'] = 'Bearer ' + getReshToken()
  }
  return config
}, error => {
  return Promise.reject();
});

// 响应拦截器,例如判断服务器返回的状态，400，500啥的，其实超时可以写到这里面来，我分开写了一个比较直观
service.interceptors.response.use(
  res => {
    // 检查并存储授权信息
    checkAndStoreAuthentication(res)
    // 处理规范化结果错误
    const serve = res.data
    if (serve && serve.hasOwnProperty.call('errors') && serve.errors) {
      // 处理规范化 401 授权问题
      if (serve.errors === '401') {
        clearAccessTokens();
        window.location.href = Vue.prototype.$loginBack;
      }
      // throwError(
      //   !serve.errors
      //     ? 'Request Error.'
      //     : typeof serve.errors === 'string'
      //       ? serve.errors
      //       : JSON.stringify(serve.errors)
      // )
      // if (serve.errors === '415 Unsupported Media Type') {
      //   console.log('415, 415')
      // }
      return
    }
    const isBaidu = res.config.url.indexOf('BaiduApi') !== -1;
    if(isBaidu) {
      if(typeof res.data === "string"){
        const hasData = res.data?.indexOf("data:") !== -1;
        if(hasData) {
          return JSON.parse(res.data.replace("data:",""))
        }
      }
    }
    return res.data
  },
  error => {
    if (error.response.status == '401') {
      window.location.href = Vue.prototype.$loginBack
    }
    // 请求错误
    // let status = "";
    // if (error.request) {
    //   status = error.request;
    // } else if (error.response) {
    //   status = error.response;
    // }
    // if (status) {
    //   switch (status.status) {
    //     case 403:
    //       error.message = "拒绝访问"
    //       break
    //   }
    // } else {
    //   error.message = "连接服务器失败!";
    // }

    // 这里编写响应错误代码

    return Promise.reject(error)
  }
)

/**
 * 检查并存储授权信息
 * @param res 响应对象
 */
export function checkAndStoreAuthentication(res) {
  // 读取响应报文头 token 信息
  var accessToken = res.headers[accessTokenKey]
  var refreshAccessToken = res.headers[refreshAccessTokenKey]

  // 判断是否是无效 token
  if (accessToken === 'invalid_token') {
    clearAccessTokens()
    // 判断是否存在刷新 token，如果存在则存储在本地
  } else if (
    refreshAccessToken &&
    accessToken &&
    accessToken !== 'invalid_token'
  ) {
    setToken(accessToken)
    setReshToken(refreshAccessToken)
    // 初始化vuex中的tonken
    store.commit('user/SET_TOKEN', getToken())

    // console.log(store.state.user)
  }
}

/**
 * 针对列表数据的响应解包
 * @param res
 * @return {Array}
 */
export function unwrapListResp(res) {
  if (res.statusCode === 200) {
    if (res.extras.apiStatusCode === 1000) {
      return res.data.dataModels;
    } else {
      console.error("错误响应: ", res);
      Message.error(res.extras.message);
      return [];
    }
  } else {
    console.error("错误响应: ", res);
    if (res.extras && res.extras.message) {
      Message.error(res.extras?.message);
    } else {
      Message.error("请求错误");
    }
    return [];
  }
}

export default service;
